const storage = { getItem: function () {}, setItem: function () {}, removeItem: function () {} }

export const sessionStorage = window.sessionStorage || storage
// 安卓版微信可能因为内存不足的原因，把localStorage放到缓存里而不能持久保存，http://www.cnblogs.com/mmmjiang13/p/4141557.html
export const localStorage = {
  getItem: function (name) {
    return window.localStorage && window.localStorage.getItem(name)
  },
  setItem: function (name, value) {
    window.localStorage && window.localStorage.setItem(name, value)
  },
  removeItem: function (name) {
    window.localStorage && window.localStorage.removeItem(name)
  },
  clear: function () {
    window.localStorage && window.localStorage.clear()
  }
}

export const getUser = () => JSON.parse(localStorage.getItem('user'))

export const setUser = (user) => localStorage.setItem('user', JSON.stringify(user))

export const removeUser = () => {
  localStorage.removeItem('user')
}

export const removeAccessToken = () => {
  localStorage.removeItem('user')
  localStorage.removeItem('token')
  localStorage.removeItem('expires_at')
}

export const getAccessToken = () => {
  const token = localStorage.getItem('token')
  const expiresAt = localStorage.getItem('expires_at')

  if (Date.now() >= expiresAt) {
    removeAccessToken()
    removeUser()
    return ''
  }

  return token
}

export const setAccessToken = (token, expiresIn) => {
  localStorage.setItem('token', token)
  localStorage.setItem('expires_at', Date.now() + expiresIn * 1000)
}

// 序列化参数，创建 URL 编码文本字符串。
export const serialize = (params, baseUrl = '') => {
  let query = ''
  Object.keys(params).forEach((entry) => {
    if (params[entry] !== null && params[entry] !== undefined && params[entry] !== '') {
      query += `${!query ? '' : '&'}${entry}=${params[entry]}`
    }
  })

  return baseUrl + (/\?/.test(baseUrl) ? '&' : '?') + query
}

export const setFullScreen = (isFull) => {
  document.body.className = isFull ? 'full-screen' : ''
}

export const addClass = (...params) =>
  params
    .filter(
      (item) =>
        (Array.isArray(item) &&
          item[0] &&
          typeof item[1] === 'string' &&
          (item[1] || '').trim() !== '') ||
        (typeof item === 'string' && (item || '').trim() !== '')
    )
    .map((item) =>
      Array.isArray(item) ? (item[0] ? item[1] : item[2] || '') : (item || '').trim()
    )
    .join(' ')

export const regExp = {
  MOBILE: /^1\d{10}$/,
  PHONE: /^([0-9]{3,4}-)?[0-9]{7,8}$/,
  PASSWORD: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,
  CREDIT_CODE: /^[0-9A-Za-z]{15,18}$/,
  NAME: /^[\u4e00-\u9fa5]{2,10}$/
}

export const syncToken = (token) => {
  return new Promise((resolve, reject) => {
    const iframeDom = document.createElement('iframe')

    iframeDom.style.display = 'none'
    iframeDom.src = process.env.VUE_APP_SELLER_ORIGIN + '/post-message'
    document.body.appendChild(iframeDom)
    iframeDom.onload = () => {
      iframeDom.contentWindow.postMessage(
        token ? `setToken|${token}` : 'removeToken',
        process.env.VUE_APP_SELLER_ORIGIN
      )
      setTimeout(() => {
        document.body.removeChild(iframeDom)
      }, 0)
      resolve()
    }
    iframeDom.onerror = (e) => {
      setTimeout(() => {
        document.body.removeChild(iframeDom)
      }, 0)
      reject(e)
    }
  })
}
